import { Component } from '@angular/core';
import { ThemeService } from 'shared/services/parameter/theme.service';

@Component({
  selector: 'app-navbar-logo',
  templateUrl: './navbar-logo.component.html',
  styleUrls: ['./navbar-logo.component.scss'],
})
export class NavbarLogoComponent {
  logoUrl: string;


  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService.logo$.subscribe(url => {
      this.logoUrl = url;
    });
  }
}
